import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function MockupSection() {
  const bullets = ['Acceso inmediato', 'Contenido 100% digital', 'Sistema completo paso a paso'];
  return <section className="relative w-full bg-black py-10 md:py-14 overflow-hidden" data-id="element-234">
      {/* Cinematic red glow backdrop */}
      <div className="absolute inset-0 z-0" data-id="element-235">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1200px] h-[900px] rounded-full bg-red-700/20 blur-[160px]" data-id="element-236" />
        <div className="absolute top-1/3 left-1/4 w-[500px] h-[500px] rounded-full bg-red-900/25 blur-[130px]" data-id="element-237" />
        <div className="absolute top-1/3 right-1/4 w-[400px] h-[400px] rounded-full bg-red-800/20 blur-[120px]" data-id="element-238" />
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0,0,0,0.5) 70%, #000 100%)'
      }} data-id="element-239" />
      </div>

      <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#0a0a0a] to-transparent z-10" data-id="element-240" />
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-[#0a0a0a] to-transparent z-10" data-id="element-241" />

      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-px bg-gradient-to-r from-transparent via-red-600 to-transparent z-20" data-id="element-242" />

      <div className="relative z-20 max-w-7xl mx-auto px-6" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-244">
          {/* Title — more compact */}
          <div className="relative mb-6 max-w-4xl mx-auto" data-id="element-245">
            <div className="absolute inset-0 blur-3xl bg-red-600/20 -z-10" data-id="element-246" />
            <h2 className="font-display text-3xl md:text-5xl uppercase text-center leading-[1.05] tracking-tight" data-id="element-247">
              <span className="text-red-500 drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]" data-id="element-248">
                👉
              </span>{' '}
              <span className="text-white drop-shadow-[0_0_25px_rgba(220,38,38,0.4)]" data-id="element-249">
                Todo lo que recibes con
              </span>{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-b from-red-500 to-red-700 drop-shadow-[0_0_30px_rgba(220,38,38,0.8)]" data-id="element-250">
                Control Total
              </span>
              <span className="block mt-1 text-white text-lg md:text-2xl tracking-wider" data-id="element-251">
                — Reset Masculino —
              </span>
            </h2>
          </div>

          {/* MOCKUP IMAGE */}
          <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 1
        }} className="relative max-w-5xl mx-auto mb-6" data-id="element-252">
            <div className="absolute -inset-6 md:-inset-10 bg-red-600/30 rounded-3xl blur-[80px] opacity-70" data-id="element-253" />
            <div className="absolute -inset-3 md:-inset-6 bg-gradient-to-b from-red-700/40 via-red-900/30 to-red-700/40 rounded-2xl blur-[50px] opacity-60" data-id="element-254" />

            <div className="relative bg-black rounded-xl overflow-hidden border border-red-900/50 shadow-[0_0_60px_rgba(220,38,38,0.25),inset_0_0_30px_rgba(0,0,0,0.8)]" data-id="element-255">
              <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-500/60 to-transparent z-10" data-id="element-256" />

              <span className="absolute top-3 left-3 w-8 h-8 border-t-2 border-l-2 border-red-500/70 z-10" data-id="element-257" />
              <span className="absolute top-3 right-3 w-8 h-8 border-t-2 border-r-2 border-red-500/70 z-10" data-id="element-258" />
              <span className="absolute bottom-3 left-3 w-8 h-8 border-b-2 border-l-2 border-red-500/70 z-10" data-id="element-259" />
              <span className="absolute bottom-3 right-3 w-8 h-8 border-b-2 border-r-2 border-red-500/70 z-10" data-id="element-260" />

              <img src="https://cdn.magicpatterns.com/uploads/nyEYJyypgV4QctySWo842u/ChatGPT_Image_8_jun_2026,_21_35_43.png" alt="Pack Control Total para hombres: 6 tomos y 6 bonos exclusivos" className="w-full h-auto block relative z-0" loading="lazy" decoding="async" data-id="element-261" />

              <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-black/30 via-transparent to-black/10 z-[1]" data-id="element-262" />
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.8,
            duration: 0.6
          }} className="absolute -top-4 right-4 md:-top-5 md:right-8 bg-gradient-to-b from-red-600 to-red-800 text-white text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full border border-red-400/50 shadow-[0_5px_20px_rgba(220,38,38,0.5)] flex items-center gap-2 z-20" data-id="element-263">
              <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" data-id="element-264" />
              Edición Completa
            </motion.div>
          </motion.div>

          {/* Bullets - compactos */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.6
        }} className="grid grid-cols-1 md:grid-cols-3 gap-3 max-w-4xl mx-auto mb-6" data-id="element-265">
            {bullets.map((bullet, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.5 + index * 0.1,
            duration: 0.5
          }} className="relative bg-[#0a0a0a]/80 backdrop-blur-sm border border-red-900/40 rounded-xl px-5 py-4 flex items-center justify-center gap-3 shadow-[0_0_20px_rgba(220,38,38,0.08)] hover:border-red-600/60 transition-all duration-500 pt-[4px] pb-[4px] pl-[10px] pr-[10px]" data-id="element-266">
                <span className="text-red-500 text-xl flex-shrink-0 drop-shadow-[0_0_10px_rgba(220,38,38,0.6)]" data-id="element-267">
                  ✔
                </span>
                <span className="text-white font-semibold text-[12px]" data-id="element-268">
                  {bullet}
                </span>
              </motion.div>)}
          </motion.div>

          {/* Quick CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6,
          duration: 0.6
        }} className="flex flex-col items-center" data-id="element-269">
            <a href="#checkout" className="group relative inline-block" data-id="element-270">
              <div className="absolute -inset-1 bg-red-600 rounded-xl blur-xl opacity-60 group-hover:opacity-90 transition-opacity duration-500" data-id="element-271" />
              <div className="absolute -inset-0.5 bg-gradient-to-r from-red-700 via-red-500 to-red-700 rounded-xl blur opacity-80 group-hover:opacity-100 transition duration-500" data-id="element-272" />

              <motion.button whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="relative flex items-center gap-3 bg-gradient-to-b from-red-600 to-red-800 text-white font-display text-lg md:text-2xl uppercase tracking-wider px-8 md:px-12 py-5 md:py-6 rounded-xl border border-red-400/40 shadow-[inset_0_1px_0_rgba(255,255,255,0.2),0_20px_50px_-15px_rgba(220,38,38,0.7)] transition-all duration-300" data-id="element-273">
                <span className="drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]" data-id="element-274">
                  👉 Quiero el sistema completo
                </span>
                <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform duration-300" data-id="element-275" />
                <span className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/15 to-transparent rounded-t-xl pointer-events-none" data-id="element-276" />
              </motion.button>
            </a>

            <p className="mt-4 text-xs md:text-sm text-gray-500 uppercase tracking-widest flex items-center gap-3" data-id="element-277">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-278" />
              Acceso inmediato · 100% digital
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}